import { inject, InjectionToken } from "@angular/core";
import { FcmMessagingProvider } from "./fcm-messaging.provider";
import { MessagingProvider } from "./messaging.types";

/** Composition root: replace this binding to select another provider adapter. */
export const MESSAGING_PROVIDER = new InjectionToken<MessagingProvider>("MESSAGING_PROVIDER", {
  providedIn: "root",
  factory: () => inject(FcmMessagingProvider),
});
